import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const PlusIconGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId = 'plusIconGe',
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.interactive.brandColor;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.90028 0.695312C8.10259 0.695312 7.45584 1.34206 7.45584 2.13976V7.55642H2.03917C1.24148 7.55642 0.594727 8.20317 0.594727 9.00087C0.594727 9.79856 1.24148 10.4453 2.03917 10.4453H7.45584V15.862C7.45584 16.6597 8.10259 17.3064 8.90028 17.3064C9.69798 17.3064 10.3447 16.6597 10.3447 15.862V10.4453H15.7614C16.5591 10.4453 17.2058 9.79856 17.2058 9.00087C17.2058 8.20317 16.5591 7.55642 15.7614 7.55642H10.3447V2.13976C10.3447 1.34206 9.69798 0.695312 8.90028 0.695312Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default PlusIconGe;
